import request from '@/utils/request'
import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_API || (process.env.NODE_ENV === 'development' ? 'https://qingquan.rwan.org.cn/api' : 'https://qingquan.rwan.org.cn/api')

export const uploadImage = (file) => {
  const form = new FormData()
  form.append('file', file)
  const token = localStorage.getItem('xjb_admin_token') || 'demo-admin-token'
  return axios.post(`${BASE_URL}/upload/image`, form, {
    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` }
  }).then(res => {
    const body = res.data
    if (body && (body.code === 200 || body.code === 0)) return body.data
    return Promise.reject(body)
  })
}

export const fetchWells = params => request({ url: '/well/list', method: 'get', params })
export const fetchWellDetail = id => request({ url: `/well/detail/${id}`, method: 'get' })
export const reportWell = data => request({ url: '/well/report', method: 'post', data })
export const auditWell = data => request({ url: '/well/audit', method: 'post', data })
export const updateWell = data => request({ url: '/well/update', method: 'post', data })
export const updateWellShelf = data => request({ url: '/well/shelf', method: 'post', data })
export const offlineWell = data => request({ url: '/well/offline', method: 'post', data })
export const deleteWell = id => request({ url: `/well/delete/${id}`, method: 'post' })

export const fetchPatrolDashboard = () => request({ url: '/patrol/dashboard', method: 'get' })
export const fetchPatrols = params => request({ url: '/patrol/list', method: 'get', params })
export const deletePatrol = id => request({ url: `/patrol/delete/${id}`, method: 'post' })

export const fetchRank = params => request({ url: '/appeal/rank', method: 'get', params })
export const fetchTestList = params => request({ url: '/admin/test/list', method: 'get', params })
export const fetchRepairList = params => request({ url: '/admin/repair/list', method: 'get', params })
export const submitTestReport = data => request({ url: '/test/report', method: 'post', data })
export const deleteTestApply = id => request({ url: `/admin/test/delete/${id}`, method: 'post' })
export const deleteRepairApply = id => request({ url: `/admin/repair/delete/${id}`, method: 'post' })

export const fetchDonations = params => request({ url: '/admin/donation/list', method: 'get', params })
export const auditDonation = data => request({ url: '/admin/donation/audit', method: 'post', data })
export const deleteDonation = id => request({ url: `/admin/donation/delete/${id}`, method: 'post' })
export const fetchClaims = params => request({ url: '/admin/claim/list', method: 'get', params })
export const auditClaim = data => request({ url: '/admin/claim/audit', method: 'post', data })
export const deleteClaim = id => request({ url: `/admin/claim/delete/${id}`, method: 'post' })

export const fetchTestProgress = params => request({ url: '/admin/test-progress/list', method: 'get', params })
export const addTestProgress = data => request({ url: '/admin/test-progress/add', method: 'post', data })
export const updateTestProgress = data => request({ url: '/admin/test-progress/update', method: 'post', data })
export const deleteTestProgress = id => request({ url: `/admin/test-progress/delete/${id}`, method: 'post' })

export const fetchRepairProgress = params => request({ url: '/admin/repair-progress/list', method: 'get', params })
export const addRepairProgress = data => request({ url: '/admin/repair-progress/add', method: 'post', data })
export const updateRepairProgress = data => request({ url: '/admin/repair-progress/update', method: 'post', data })
export const deleteRepairProgress = id => request({ url: `/admin/repair-progress/delete/${id}`, method: 'post' })

export const fetchClues = params => request({ url: '/admin/clue/list', method: 'get', params })
export const addClue = data => request({ url: '/admin/clue/add', method: 'post', data })
export const updateClue = data => request({ url: '/admin/clue/update', method: 'post', data })
export const deleteClue = id => request({ url: `/admin/clue/delete/${id}`, method: 'post' })

export const fetchUsers = params => request({ url: '/admin/user/list', method: 'get', params })
export const updateUserStatus = data => request({ url: '/admin/user/status', method: 'post', data })
export const updateUserRole = data => request({ url: '/admin/user/role', method: 'post', data })
export const deleteUser = id => request({ url: `/admin/user/delete/${id}`, method: 'post' })
